<template>
  <div>
    <v-divider :key="element.id_produttore + '-div1'" />
    <v-row
      :key="element.id_produttore + 'row1'"
      class="pl-2 py-2"
      no-gutters
      align="center"
    >
      <v-col
        cols="11"
        @click="showVarieta = !showVarieta"
        style="cursor: pointer"
      >
        <v-avatar>
          <v-img :src="avatar_fornitore" />
        </v-avatar>
        <span class="ml-4 text-h6 green--text font-weight-light">{{
          fornitore.nome
        }}</span>
      </v-col>
      <v-col cols="1">
        <StampaVarieta
          :id_prodotto="id_prodotto"
          :id_fornitore="element.id_produttore"
          v-if="daProdotto"
        />
      </v-col>
    </v-row>
    <v-divider :key="element.id_produttore + '-div2'" v-if="showVarieta" />
    <template v-if="showVarieta">
      <template v-for="varieta in element.varieta">
        <VarietaElement
          :varieta="varieta"
          :id_specie="specie.id"
          :series="specie.series"
          :key="varieta.id"
        />
      </template>
    </template>
  </div>
</template>

<script>
import VarietaElement from "./varieta_element.vue";
import StampaVarieta from "./stampa_varieta.vue";

export default {
  components: {
    VarietaElement,
    StampaVarieta,
  },
  props: {
    element: Object,
    id_prodotto: String,
    daProdotto: Boolean,
    specie: Object,
  },
  data() {
    return {
      showVarieta: true,
    };
  },
  computed: {
    fornitore() {
      return this.$store.getters.get_fornitore_by_id(
        this.element.id_produttore
      );
    },
    avatar_fornitore() {
      return (
        process.env.VUE_APP_API_ROOT +
        "/fornitore/" +
        this.element.id_produttore +
        "/avatar"
      );
    },
  },
  methods: {},
};
</script>